import { call, put, select } from 'redux-saga/effects';
import { chatBlobUrlsCleared, selectAllOptimisticImageBlobs } from 'features/chat/chatSlice';
import { clearPendingImagesSaga } from 'features/chat/sagas/clearPendingImagesOnChatChangeSaga';
import { revokeBlobUrls } from 'features/chat/utils/revokeBlobUrls';
import { chatImageUploadManager } from 'utils/chat-image-upload/ChatImageUploadManager';

export function* cancelAllChatUploadsSaga() {
  yield call([chatImageUploadManager, chatImageUploadManager.cancelAll]);

  const blobsByMessage: Record<string, string[]> = yield select(selectAllOptimisticImageBlobs);
  const urls = Object.values(blobsByMessage).flat();
  if (urls.length > 0) {
    yield call(revokeBlobUrls, urls);
    yield put(chatBlobUrlsCleared());
  }

  yield call(clearPendingImagesSaga);
}
